export default __webpack_public_path__ + "static/media/documents.7a9c7a96.svg";